import { lazy } from 'react';

export const PurpleCoupon = lazy(() => import('./PurpleCoupon/PurpleCoupon'));
export const GiftCoupon = lazy(() => import('./GiftCoupon/GiftCoupon'));
export const OutsideBoxCoupon = lazy(() => import('./OutsideBoxCoupon/OutsideBoxCoupon'));
export const DarkCoupon = lazy(() => import('./DarkCoupon/DarkCoupon'));
export const DimensionalCoupon = lazy(() => import('./DimensionalCoupon/DimensionalCoupon'));
